import { useEffect, useState } from 'react'
import s from './index.module.css'
import { GetIco, SupportIcon } from '@/utils/icons'
import { Link, NavLink } from 'react-router-dom'
import cn from 'classnames'
import { connect, useDispatch, useSelector } from 'react-redux'
import { ButtonEditNew } from '@UI/Button'
import { selectProfile } from '@store/profile.reducer'
import { formateName } from '@helpers/formateName'
import { getAvatar } from '@helpers/getAvatar'
import { selectorOwnBacklogCount } from '@store/children/children.reducer'
import { selectorTotalCountUHW } from '@store/seminarian/seminarian.reducer'
import setSettingsFromServer from '@/helpers/setSettingsFromServer'
import { fetchMenu } from '@store/menu.reducer'
import classNames from 'classnames'
import BalanceBlock from '@UI/BalanceBlock'
import QModals from '@pages/Main/Requests/Qmodals'
import LicenseAndPaymentButton from './components/LicenseAndPaymentButton/LicenseAndPaymentButton'
import SupportHelper from './components/SupportHelper/SupportHelper'
import { useIsMinimizedMenu } from '@/hooks/useIsMinimizedMenu'
import { actionExpandedMenu, actionMinimizedMenu } from "@store/menu.reducer";
import {CompressIcon, OpenViewIcon} from "@/utils/icons";
import { useScreenWidth } from '@/hooks/useScreenWidth'
import { Tooltip } from 'antd'
import backgraundColorList from './backgraundColorList'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'
import tooltip from 'antd/es/tooltip'

const Sidebar = () => {
  const isMinimizedMenu = useIsMinimizedMenu();
  const isMinimized = useSelector((state) => state.menu.isMinimized);
  const dispatch = useDispatch();
  const toggleMenu = () => {
    if(isMinimized) {
      dispatch(actionExpandedMenu()) 
    } 
    else{
      dispatch(actionMinimizedMenu())
    }
  }
  const profile = useSelector(selectProfile)
  const isShow = useSelector((state) => state.page.showSidebar)
  const [logo, setLogo] = useState('/logo.svg')
  const [show, setShow] = useState(false)
  const [type, setType] = useState(false)
  const handleClick = () => {
    if(['admin', 'junior-admin'].includes(profile?.role)) return
    setShow(true)
    setType('ProblemSite')
  }
  const balance = profile?.balance !== undefined ? profile.balance : 0
  const [settings, setSettings] = useState(null)
  useEffect(() => {
    setSettingsFromServer(setSettings)
  }, [])

  useEffect(() => {
    if (settings?.mainLogo) {
      setLogo(process.env.REACT_APP_PATH_FILE + settings?.mainLogo)
    }
  }, [settings])

  const hasAnyAdmin = ['admin', 'junior-admin'].some((item) =>
    profile?.roles?.includes(item),
  )

  const hasRoleAdmin = ['admin'].some((item) =>
    profile?.roles?.includes(item),
  )

  const isMobile = useScreenWidth(991);

  const isShowSupportButton = () => {
    if(['admin', 'junior-admin']?.includes(profile?.role)){
      return true
    }
    if(settings?.isDisableStudentSupportRequests === '1' && ['children']?.includes(profile?.role)){
      return false
    }
    if(settings?.isDisableEmployeeSupportRequests === '1' && ['personal-manager', 'seminarian', 'senior-seminarian', 'hr-manager']?.includes(profile?.role)){
      return false
    }
    if(settings?.isDisableParentSupportRequests === '1' && ['parent']?.includes(profile?.role)){
      return false
    }
    return true
  }

  return (
    <>
      <aside className={cn({ [s.show]: isShow }, 'app-sidebar', s.barWrapper, {[s.barWrapperMinimized]: isMinimizedMenu})}>
        <div className={s.contentWrapper}>
          {
            !isMobile && (
                <button className={s.toggleMenu} onClick={toggleMenu}>
                {isMinimized ? <OpenViewIcon viewBox="7 7 10 10" width='10' height='10'/> : <CompressIcon />}
            </button>
            )
          }
          
          <div className={classNames(s.userInfo, {[s.center]: isMinimizedMenu})}>
            <div className={s.logoWrapper}>
              {
                !isMinimizedMenu && <img
                  className={s.avatar}
                  src={getAvatar(profile)}
                  alt={profile?.name}
                />
              }
              {
                isMinimizedMenu && <Link to="/personal">
                  <img
                    className={s.avatar}
                    src={getAvatar(profile)}
                    alt={profile?.name}
                  />
                </Link>
              }
            </div>
            {
              !isMinimizedMenu && (
                <div className={s.userData}>
                  <div className={s.fio}>
                    {formateName(profile?.name, 'F I')}
                    {showUserCustomId(profile)}
                  </div>
                  <div className={s.mail}>{profile?.email}</div>
                  <Link to="/personal" className={s.linkEdit}>
                    <ButtonEditNew className={s.btnEdit} />
                  </Link>
                </div>
              )
            }
           
          </div>
          <NavigationApp />
        </div>

        <div className={s.sidebarFooter}>
          {
            !isMinimizedMenu && settings?.isUniversalBalance === '1' && <BalanceBlock />
          }
          {hasRoleAdmin && (
            <LicenseAndPaymentButton
              className={classNames(s.support, s.navLink)}
            />
          )}
          {
            isShowSupportButton() && <SupportHelper isDisabled={!hasAnyAdmin}>
              <Tooltip title={isMinimizedMenu ? 'Поддержка' : ''} placement='right'>
                <div onClick={handleClick} 
                  title={!isMinimizedMenu ? 'Поддержка' : ''} 
                  className={classNames(s.support, {[s.center]: isMinimizedMenu}, s.navLink)}>
                  <SupportIcon />
                  {!isMinimizedMenu ? 'Поддержка' : ''}
                </div>
              </Tooltip>
            </SupportHelper>
          }
        </div>
      </aside>
      <QModals type={type} active={show} setActive={setShow} />
    </>
  )
}

export default Sidebar

const MenuItem = ({ onClose, ...props }) => {
  const item = props.item
  const title = props.item?.title

  const isMobile = useScreenWidth(991);

  if (item.url.startsWith('http'))
    return (
      <Tooltip title={props.isMinimizedMenu ? title : ''} placement='right'>
        <a
          href={item.url}
          onClick={onClose}
          className={classNames(s.navLink, {[s.center]: props.isMinimizedMenu })}
          target="_blank"
          rel="noreferrer"
          title={!props.isMinimizedMenu ? title : ''}
        >
          <GetIco icon={item.icon} className={classNames(s.navIco, {[s.navIcoMR]: !props.isMinimizedMenu })} />
          {!props.isMinimizedMenu ? title : ''}
        </a>
      </Tooltip>
    )

  return (
    <Tooltip title={props.isMinimizedMenu ? title : ''} placement='right'>
       <NavLink
        exact={item.url === '/' && true}
        to={item.url}
        onClick={onClose}
        className={classNames(s.navLink, {[s.center]: props.isMinimizedMenu })}
        activeClassName={s.active}
        title={!props.isMinimizedMenu ? title : ''}
      >
        <GetIco icon={item.icon} className={classNames(s.navIco, {[s.navIcoMR]: !props.isMinimizedMenu })} /> {!props.isMinimizedMenu ? title : ''}
        {/*{item.has_notify && <Notify url={item.url} />}*/}
        <div className={s.noticeWrapper}>
          {item?.notice && Array.isArray(item.notice) && item.notice.filter((n) => n?.value !== null && n?.value !== undefined).map((notice, index) => (
            <TooltipWrapper title={(notice?.tooltip && !isMobile) ? notice?.tooltip : undefined} key={index} className={s.noticeTooltip}>
              <span
                className={cn('notice', s.notice)}
                style={notice?.color ? { backgroundColor: notice.color } : { }}
              >
                {notice?.value}
              </span>
            </TooltipWrapper>
          ))}
          {item?.noticeCount > 0 && !props.isMinimizedMenu && (
            <span className={cn('notice', s.notice)}>{item.noticeCount}</span>
          )}
        </div>
      </NavLink>
    </Tooltip>
  )
}

export const NavigationApp = connect((state) => ({ menu: state.menu.items }), {
  fetchMenu,
})(({ menu, fetchMenu, onClose }) => {
  const isMinimizedMenu = useIsMinimizedMenu();
  useEffect((_) => {
    fetchMenu()
  }, [])

  return (
    <nav className={cn(s.navList, 'list-reset')}>
      {menu &&
        menu?.map((menuItem, i) => (
          <FolderItem
            folder={menuItem.folder}
            isMinimizedMenu={isMinimizedMenu}
            index={i}
            key={i}
          >
            {menuItem.items?.map((item) => (
              <MenuItem key={item.id} item={item} onClose={onClose} isMinimizedMenu={isMinimizedMenu} />
            ))}
          </FolderItem>
        ))
      }
    </nav>
  )
})

const FolderItem = ({
  folder,
  isMinimizedMenu,
  children,
  index
}) => {
  const [isOpen, setIsOpen] = useState(false);
  if (!folder)
    return <>{ children }</>;
  if (folder.is_active == 0)
    return <></>;

  const title = folder?.title

  return (<div className={s.folder}>
    <Tooltip title={isMinimizedMenu ? title : ''} placement='right'>
       <div
        className={classNames(s.folderNavLink, s.navLink, {[s.center]: isMinimizedMenu })}
        activeClassName={s.active}
      >
        <div
          className={s.folder_block}
        >
          <div
            className={s.folderTitle}
            style={{ background: backgraundColorList[index % backgraundColorList.length] }} 
            onClick={() => setIsOpen(!isOpen)}
          >
            <GetIco
              icon='folder'
              className={classNames(s.navIco, {[s.navIcoMR]: !isMinimizedMenu })}
            />
            {!isMinimizedMenu ? title : ''}
            <GetIco
              icon={ isOpen ? 'angle_arrow_down' : 'angle_arrow_up' }
              className={classNames(s.arrow, {[s.arrow2]: true})}
            />
          </div>
          { isOpen && children }
        </div>
      </div>
    </Tooltip>
  </div>)
}

const Notify = ({ url }) => {
  let count = 0
  const unverifiedHWCount = useSelector(selectorTotalCountUHW)
  if (url === '/dz-students' && unverifiedHWCount > 0) count = unverifiedHWCount

  const ownBacklogCount = useSelector(selectorOwnBacklogCount)
  if (url === '/home-work' && ownBacklogCount > 0) count += ownBacklogCount

  if (count === 0) return <></>
  return <span className={cn('notice', s.notice)}>{count}</span>
}

function showUserCustomId(profile) {
  let customId = profile?.custom_id

  return customId && <span className={s.customId}>{customId}</span>
}
